import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ dataComponents: { drawer }, shadows }: ComposedTheme) => ({
  background: {
    '& input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
      {
        '-webkit-box-shadow': `0 0 0px 1000px ${drawer.backgroundColor} inset`,
        '-webkit-text-fill-color': `${drawer.text.color} !important`,
      },
    '& input:autofill': {
      fontFamily: drawer.text.font.fontFamily,
      backgroundColor: drawer.backgroundColor,
    },
    backgroundColor: drawer.backgroundColor,
    minHeight: '100%',
    maxHeight: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  drawer: {
    boxShadow: shadows.left,
  },
  closeButton: {
    '& svg': {
      fill: drawer.closeIconColor,
    },
    cursor: 'pointer',
    position: 'absolute',
    right: 17,
    top: 20,
  },
  headerWrapper: {
    padding: '50px 6px 0',
    paddingLeft: 15,
  },
  tab: {
    color: drawer.tabColor,
  },
});

export default createUseStyles(styles);
